import { useEffect, useState } from "react";
import { Outlet, useNavigate , useLocation } from "react-router-dom";
import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Navbar from "./components/Navbar";
import Loading from "./components/Loading";
import Footer from "./components/Footer";
import {useAppContext} from "./components/AppProvider"    

import {ScrollToTop} from "./components/ScrollToTop"


gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);

export default function Layout(prop) {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  const { gpageTransition } = useAppContext();

  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const filesToLoad = [
    "/assets/img/about/khawar.webp",
    "/assets/img/about/khurram.webp",
    "/assets/img/about/zari.webp",
    
    "/assets/img/home/portfolio/1.webp",
    "/assets/img/home/portfolio/2.webp",
    "/assets/img/home/portfolio/3.webp",


    "/assets/img/logo-header.svg",
    "/assets/img/services/brand-building/hero-image.webp",
    "/assets/img/services/web-ui-ux-design/hero-image.webp",
    "/assets/img/services/web-development-e-commerce/hero-image.webp",
    "/assets/img/services/marketing-collateral/hero-image.webp",
    "/assets/img/services/motion-graphics/hero-image.webp",
    





  ];

  
  // Navigation link to GSAP Logic
  useEffect(() =>
  {
    // Transition Logic
    $('a').each(function(m)
    {
      $(this).click(function(e)
      {
        
          if((this.classList.toString().indexOf('native') <0) && (this.classList.toString().indexOf('btn-native') <0)  )
          {
            const href = this.getAttribute('href');
            e.preventDefault();
            gpageTransition(href.toString());
          }
      });
    });
  });


  return (
    <>
      <ScrollToTop />
      <main>
        <ul className="transition">
          <li className="wrapper" id="transitionText"></li>
        </ul>
        <Loading files={filesToLoad} onComplete={() => setIsPageLoaded(true)} currentPath={currentPath} isPageLoaded={isPageLoaded} />

          {isPageLoaded === true ?<> <Navbar /> <Outlet  /> <Footer /></> : ""
        
          }
        
      </main>
      
    </>
  );
}
